import(/* webpackMode: "eager" */ "/app/app/[lang]/login/page.tsx");
